import { Card } from '@firi/ui-web';
import { Trans } from '@lingui/macro';
import { useScrollToHeaders } from 'hooks/useScrollToHeaders';
import { Post, Settings } from 'types/schema';

import { TableOfContents } from '../TableOfContents';
import { Typography } from '../Typography';

type ArticleSidebarProps = Pick<Post, 'body' | 'blogPitch' | 'sections'> &
  Pick<Settings, 'disclaimer'>;

export const ArticleSidebar = ({ data }: { data: ArticleSidebarProps }) => {
  const { headers, handleScrollTo } = useScrollToHeaders([
    ...(data.body ? data.body : []),
    ...(data.sections ? data.sections : []),
  ]);

  return (
    <aside>
      <Card className="space-y-10 p-10">
        <TableOfContents headers={headers} handleScrollTo={handleScrollTo} />
        <div className="space-y-4">
          <Typography as="h3" size="lg" color="blue">
            <Trans>Short summary</Trans>
          </Typography>
          <Typography as="p" size="sm">
            {data.blogPitch}
          </Typography>
        </div>
        {data.disclaimer?.text && (
          <Typography as="p" size="xs" className="italic">
            {data.disclaimer.text}
          </Typography>
        )}
      </Card>
    </aside>
  );
};
